import React from 'react'
const Footer=()=> {
  return (
    <footer className="footer">
            <h4>Made by Chirag Gupta</h4>
            <nav>
                <ul className="spaced-list spaced-list-icons mt-1">
                    <li>
                        <a href="https://twitter.com/Chirag__dev">
                            <i className='bx bxl-twitter social-icons'></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://github.com/Hardiegogo/Modinate_UI">
                            <i className='bx bxl-github social-icons'></i>
                        </a>
                    </li>

                    <li>
                        <a href="https://www.linkedin.com/in/chirag-dev/">
                            <i className='bx bxl-linkedin social-icons'></i>
                        </a>
                    </li>
                </ul>

            </nav>

        </footer>
  )
}

export default Footer